import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import * as React from "react";

export const ChevronLeftIcon = (props: SvgIconProps) => {
    const { viewBox = "0 0 20 20", ...rest } = props;

    return (
        <SvgIcon viewBox={viewBox} {...rest}>
            <polygon points="12.65 17.6 5.89 9.99 12.86 2.4 13.74 3.21 7.51 10.01 13.55 16.8 12.65 17.6"/>
            <rect style={{ fill: "none" }} width="20" height="20" transform="translate(20 20) rotate(-180)"/>
        </SvgIcon>
    );
};
